import { MoreHorizontalIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { Button } from '../button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '../dropdown-menu'

interface Props {
    children: ReactNode
}

export default function OptionMenu({ children }: Props) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost">
                    <MoreHorizontalIcon className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="end">
                {children}
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
